// extracted by mini-css-extract-plugin
export default {"ContentMenu":"index__ContentMenu--c1AUB","contentMenu":"index__ContentMenu--c1AUB"};